<template>
    <div class="col-md-12">
      <label>Mídias (URL):</label>
      <div class="d-flex">
        <b-form-input
          v-model="novaMidia"
          placeholder="Insira a URL da mídia"
          class="mr-2"
        ></b-form-input>
        <b-button variant="primary" @click="adicionarMidia">Adicionar</b-button>
      </div>
      <ul class="mt-2">
        <li
          v-for="(midia, index) in value"
          :key="index"
          class="d-flex justify-content-between align-items-center"
        >
          <span>{{ midia }}</span>
          <b-button variant="danger" size="sm" @click="removerMidia(index)">
            Remover
          </b-button>
        </li>
      </ul>
    </div>
  </template>

<script>
export default {
  name: 'NxInputMidias',
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      novaMidia: ''
    }
  },
  methods: {
    adicionarMidia () {
      const url = this.novaMidia.trim()
      console.log('URL digitada:', url)
      console.log('Lista atual de mídias:', this.value)
      if (url && (!this.value || !this.value.includes(url))) {
        const midiasAtualizadas = this.value ? [...this.value, url] : [url]
        this.$emit('input', midiasAtualizadas)
        this.novaMidia = ''
      } else if (!url) {
        alert('Por favor, insira uma URL válida.')
      } else {
        alert('Essa URL já foi adicionada.')
      }
    },
    removerMidia (index) {
      const novaLista = [...this.value]
      novaLista.splice(index, 1)
      this.$emit('input', novaLista) // Atualiza o v-model com a lista modificada
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/inputs/NxInputMidias.vue